import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initiatives } from "@/mocks/sustainability";

export default function InitiativesGrid() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!root.current) return;
    const ctx = gsap.context(() => {
      gsap.from(".initiative-card", {
        y: 60,
        opacity: 0,
        duration: 1,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 70%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} className="bg-bone py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-14 md:mb-20">
          <p className="text-[11px] font-mono uppercase tracking-[0.22em] text-ink/50 mb-4">
            ✦ What we are doing
          </p>
          <h2 className="font-display text-4xl md:text-6xl text-ink tracking-tightest font-light leading-[0.95]">
            Six initiatives, <span className="font-display text-rust">zero greenwashing.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {initiatives.map((item) => (
            <div
              key={item.title}
              className="initiative-card group p-8 md:p-10 rounded-[24px] bg-sand/40 hover:bg-sand/70 transition-colors"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-forest/10 text-forest mb-8">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-display text-2xl text-ink tracking-tightest font-medium">
                {item.title}
              </h3>
              <p className="mt-4 text-ink/70 text-sm md:text-base leading-relaxed">
                {item.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}